import { render, staticRenderFns } from "./feeConfigManageList.vue?vue&type=template&id=3b6fc7c2&scoped=true"
import script from "./feeConfigManageList.vue?vue&type=script&lang=js"
export * from "./feeConfigManageList.vue?vue&type=script&lang=js"
import style0 from "./feeConfigManageList.vue?vue&type=style&index=0&id=3b6fc7c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6fc7c2",
  null
  
)

export default component.exports